module.exports = __webpack_public_path__ + "static/media/keysplaceholder.02fece83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keysplaceholder.png
// module id = 1544
// module chunks = 0